import { render } from "./IncomingParcel.vue?vue&type=template&id=2dc70302"
import script from "./IncomingParcel.vue?vue&type=script&lang=js"
export * from "./IncomingParcel.vue?vue&type=script&lang=js"

import "./IncomingParcel.vue?vue&type=style&index=0&id=2dc70302&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__